import { motion } from "framer-motion";
import { SectionHeading } from "./Reveal";

const STAGES = [
  { num: "01", title: "Discover", desc: "Understand business goals, users, systems and opportunities." },
  { num: "02", title: "Design", desc: "Architecture, experience, AI, data and workflow design." },
  { num: "03", title: "Build", desc: "Engineering, integration, automation and deployment." },
  { num: "04", title: "Operate & Grow", desc: "Monitoring, optimization, AI improvements and continuous evolution." },
];

export const HowWeWork = () => (
  <section data-testid="how-we-work-section" className="py-24 sm:py-32 bg-jx-mist">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <SectionHeading
        testId="how-we-work"
        overline="How We Work"
        title={<>From idea to <span className="jx-gradient-text">impact.</span></>}
      />
      <div className="mt-16">
        {STAGES.map((s, i) => (
          <motion.div
            key={s.num}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-10%" }}
            transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: i * 0.08 }}
            data-testid={`stage-row-${i}`}
            className="group grid grid-cols-[auto_1fr] md:grid-cols-[180px_1fr_1fr] items-baseline gap-6 md:gap-12 py-10 border-t border-jx-ink/10 last:border-b hover:bg-white/60 transition-colors duration-500 px-4 md:px-8 -mx-4 md:-mx-8 rounded-xl"
          >
            <span className="font-editorial italic text-5xl md:text-7xl jx-outline-text group-hover:jx-gradient-text transition-all duration-500 select-none">{s.num}</span>
            <h3 className="font-display font-extrabold text-2xl md:text-4xl tracking-tighter text-jx-ink">{s.title}</h3>
            <p className="col-span-2 md:col-span-1 text-base text-jx-ink/55 leading-relaxed max-w-md">{s.desc}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
